module.exports = __webpack_public_path__ + "static/default_collection_header-c1ebe0b7a7a07fa1f61e49e25643eeb1.jpg";